import { SelectProps } from "@cofano/cck/Select/Select";
import { DemurrageTerms } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const DemurrageTermsSelect = ({ value, onChange }: Omit<SelectProps<DemurrageTerms, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(DemurrageTerms)}
			getOptionLabel={(option) => intl.formatMessage({ id: `DEMURRAGE_TERMS_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default DemurrageTermsSelect;
